import helpers from '@/helpers'

import { fetch } from '..'

const getAllConfig = {
  postType: 'post',
  body: {}
}

export default {
  async get (id, config = {}) {
    config = Object.assign({}, getAllConfig, config)
    if (window.lang) config.lang = window.lang
    const body = helpers.createBody(config.body)
    let response = await fetch(`/wp-json/wpvue/v1/prev-next/${config.postType}/${id}?${body}`)
    let data = await response.json()
    if (response.ok && data) {
      return data
    } else {
      return []
    }
  }
}
